import createUserManager from './create-usermanager';
import { userManagerConfig } from './oidc-client-usermanager-config';
import { getLogger } from '../../../common/logger';

/**
 * Please refer the document to know what each function does.
 * https://github.com/IdentityModel/oidc-client-js/wiki
 */

const logger = getLogger('oidc-client-usermanager');

const usermanager = createUserManager(userManagerConfig());

/**
 * Returns promise to trigger a redirect of the current window
 * to the authorization endpoint.
 */

export const signInRedirect = async () => {
  try {
    const route = { url: window.location.pathname };
    await usermanager.signinRedirect({ state: route });
  } catch (error) {
    logger.error('signInRedirect error', error);
  }
};

/**
 * Returns promise to load the User object for,
 *  the currently authenticated user.
 */

export const getAuthenticatedUser = async () => {
  const oidcUser = await usermanager.getUser();
  if (oidcUser) {
    return oidcUser;
  }
  return null;
};

/**
 * Returns promise to notify the parent window of,
 *  response from the authorization endpoint.
 */

export const silentRenewalCallback = async () => {
  try {
    await usermanager.signinSilentCallback();
  } catch (error) {
    logger.error('signinSilentCallback error', error);
  }
};

export default usermanager;
